export default __webpack_public_path__ + "static/media/board-mockup-beach.c4970b06.png";